/**
 * ROWIE — Collection feature carousel
 *
 * Progress rail plus arrows over a native scroll-snap track. Scrolling
 * stays native so touch and trackpad behave as expected; the arrows
 * just nudge it by roughly one screen.
 */

(function () {
  const ROOT = '[data-cfeature-carousel]';

  function init(root) {
    const track = root.querySelector('[data-cfeature-track]');
    const fill = root.querySelector('[data-cfeature-fill]');
    const prev = root.querySelector('[data-cfeature-arrow="prev"]');
    const next = root.querySelector('[data-cfeature-arrow="next"]');

    if (!track) return;

    const EDGE = 2;

    function update() {
      const max = track.scrollWidth - track.clientWidth;

      if (max <= EDGE) {
        if (fill) fill.style.width = '100%';
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }

      const ratio = track.scrollLeft / max;
      const view = Math.max((track.clientWidth / track.scrollWidth) * 100, 12);

      if (fill) {
        fill.style.width = view + '%';
        fill.style.left = ratio * (100 - view) + '%';
      }

      if (prev) prev.disabled = track.scrollLeft <= EDGE;
      if (next) next.disabled = track.scrollLeft >= max - EDGE;
    }

     function step(dir) {
      // Move by whole slides rather than a fraction of the viewport, so
      // the scroll always lands on a snap point. A percentage of the
      // track width drifts out of alignment as slide widths change.
      const slide = track.querySelector('li, .rowie-cfeature__slide');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const amount = slide
        ? slide.getBoundingClientRect().width + gap
        : track.clientWidth * 0.8;

      track.scrollBy({ left: dir === 'next' ? amount : -amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => step('prev'));
    if (next) next.addEventListener('click', () => step('next'));
    track.addEventListener('scroll', update, { passive: true });

    let frame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    });

    update();

    // Tile images can change the track width once they load.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }
    window.addEventListener('load', update);
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(ROOT).forEach((r) => r.removeAttribute('data-initialised'));
    initAll();
  });
})();